module.exports = __webpack_public_path__ + "static/assets/c92706889a3b3c9d3d6e9396e11cc50f.png";